import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { videoList } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  title: yup.string().required(),
  videoType: yup.string().required(),
  video: yup.mixed().required(),
  status: yup.string().required(),
});

function VideoAction(props) {
  const dispatch = useDispatch();
  const { title, category, video, status, orderby, api, id, buttonTitle, videoType } =
    props;
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { getCatsFrontEndData } = useSelector((state) => state.frontEndReducer);
  return (
    <>
      <Button
        variant={buttonTitle === "Update Video" ? "primary" : "success"}
        onClick={handleShow}
      >
        {buttonTitle === "Update Video" ? (
          <i className="bi bi-pencil-square"></i>
        ) : (
          "Add New Video"
        )}
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{buttonTitle}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            setLoader(true);
            const apiResp = await dispatch(api(values));
            if (apiResp?.payload?.status) {
              setLoader(false);
              resetForm();
              handleClose();
              dispatch(videoList());
            }
          }}
          initialValues={{
            title,
            category : category ? category : '',
            video,
            status,
            orderby,
            id,
            videoType
          }}
        >
          {({ handleSubmit, handleChange, values, setFieldValue, errors }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="title"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      isInvalid={!!errors.title}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.title}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik02">
                    <Form.Label>Orderby</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Orderby"
                      name="orderby"
                      value={values.orderby}
                      onChange={handleChange}
                      isInvalid={!!errors.orderby}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.orderby}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik03">
                    <Form.Label>Category</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={async (e) => {
                        setFieldValue("category", e.target.value);
                      }}
                      name="category"
                      className="form-control"
                      value={values.category}
                      isInvalid={!!errors.category}
                    >
                      <option value="">Select Category</option>
                      {!!getCatsFrontEndData &&
                        getCatsFrontEndData?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik04">
                    <Form.Label>Status</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={async (e) => {
                        setFieldValue("status", /true/.test(e.target.value));
                      }}
                      name="status"
                      className="form-control"
                      value={values.status}
                      isInvalid={!!errors.status}
                    >
                      <option value="">Select Status</option>
                      <option value={true}>True</option>
                      <option value={false}>False</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik05">
                    <Form.Label>Video Type</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={async (e) => {
                        setFieldValue("videoType", e.target.value);
                      }}
                      name="videoType"
                      className="form-control"
                      value={values.videoType}
                      isInvalid={!!errors.videoType}
                    >
                      <option value="">Video Type</option>
                      {/* <option value={"url"}>Link</option> */}
                      <option value={"Video"}>Video</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6} sm={12}>
                  {values.videoType === "url" ? (
                    <Form.Group controlId="validationFormik06">
                      <Form.Label>Video Url</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Video URL"
                        name="video"
                        value={values.video}
                        onChange={handleChange}
                        isInvalid={!!errors.video}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.video}
                      </Form.Control.Feedback>
                    </Form.Group>
                  ) : (
                    <Form.Group controlId="validationFormik07">
                      <Form.Label htmlFor="myfile">Real</Form.Label>
                      <Form.Control
                        id="myfile"
                        type="file"
                        name="video"
                        accept="video/*" // ⬅️ This restricts to only video files
                        onChange={(event) => {
                          const resumeFile = event.target.files[0];
                          setFieldValue("video", resumeFile);
                        }}
                        isInvalid={!!errors.video}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.video}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit" disabled={loader ? true : false}>
                  Submit
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default VideoAction;
